import React from 'react';

function Merchant() {
  return (
    <div style={{ padding: '20px' }}>
      <h2>Merchant Services</h2>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
    </div>
  );
}

export default Merchant;